import { createFileRoute } from '@tanstack/react-router'
import UserDashboard from '../pages/(User)/Dashboard/UserDashboard'
import AppLayout from '../layouts/AppLayout'

export const Route = createFileRoute('/my-program')({
  component: MyProgramComponent,
})

function MyProgramComponent() {
  return (
    <AppLayout>
      <UserDashboard />
    </AppLayout>
  )
}
